.certificationStatesCell {
    align-items: center;
    gap: var(--certification-states-cell-gap);
}

.addCertification {
    color: var(--certification-states-cell-add-color);
    font-family: var(--certification-states-cell-add-font-family);
    font-size: var(--certification-states-cell-add-font-size);
    font-weight: var(--certification-states-cell-add-font-weight);
    text-decoration: underline;
}
